import { Browser } from './Browser.js';

const browserLocale = Browser.getBrowserLocale();
const supportsIntl = typeof Intl !== 'undefined' && Intl;
class Currency {
  static legacyFormat(amount, removeTrailingZeros, zerosRegex, currency) {
    const formattedNumber = removeTrailingZeros ? amount.replace(zerosRegex, '') : amount;
    return `${formattedNumber} ${currency || ''}`.trim();
  }
  static format(amount, currency) {
    let removeTrailingZeros = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let locale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : browserLocale;
    const zerosRegex = new RegExp(/\D00$/);
    const amountAsFloat = parseFloat(amount.toString()).toFixed(2);
    const minimumFractionDigits = removeTrailingZeros && zerosRegex.test(amountAsFloat) ? 0 : 2;
    const formattedNumber = supportsIntl ? Intl.NumberFormat(locale, {
      ...(currency && {
        currency,
        style: 'currency'
      }),
      minimumFractionDigits
    }).format(amount) : this.legacyFormat(amountAsFloat, removeTrailingZeros, zerosRegex, currency);
    return formattedNumber;
  }
  static getCurrencySymbol(currency, locale) {
    return Currency.format('forceNaN', currency, undefined, locale).replace('NaN', '').trim();
  }
  static replaceI18n(text, currency, removeTrailingZeros, locale) {
    return text.replace(/(?:(\d+(?:\.)?\d+)(?:CURRENCY))/g, (_match, numberToFormat) => Currency.format(numberToFormat, currency, removeTrailingZeros, locale));
  }
}

export { Currency };
//# sourceMappingURL=Currency.js.map
